  <template>
  <SubContent @back="$router.go(-1)">
    <template v-slot:nav_left>
      数据详情
    </template>
    <div v-show="!loading" class="scroll_wrap">
      <vue-scroll>
        <div class="info_item" style="margin-bottom: 10px">
          <div class="info_title">
            <img src="@/assets/images/common/player_information.png" alt="">
            基础信息 <span><span v-if="body.official === 1" style="color:#eb2c2c">（官方测试）</span></span>
          </div>
          <div class="base_info">
            <div class="info">
              <div class="col">
                <span>测试批次：{{body.templateTitle}}</span>
                <span>测试时间：{{body.testTime | time() }}</span>
              </div>
              <div class="col">
                <span>测试联系人：{{body.linkMen}}</span>
                <span>测试联系人手机号：<yioks-privacy-text type="phone" :value="body.linkMenPhone" /></span>
              </div>
              <div class="col">
                <span>单位：{{ body.organShortName + ' ' + body.youthShortName}}</span>
                <span>测试海拔 ：{{body.testRegion | testRegionFilter}}</span>
              </div>
              <div class="col">
                <span>测试地点 ：{{body.testAddress || '--'}}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="info_item" style="margin-bottom: 10px">
          <div class="info_title">
            <img src="@/assets/images/common/player_information.png" alt="">
            测试设备符合要求的项目
          </div>
          <div class="body-info-indicator">
            <el-checkbox-group v-model="checkIndicatorList" disabled>
              <el-checkbox
                v-for="item in indicatorList"
                :key="item.uuid"
                :label="item.uuid"
                >{{item.indicatorName}}</el-checkbox>
            </el-checkbox-group>
          </div>
        </div>
        <div class="info_item" style="margin-bottom:0">
          <div class="info_title" style="justify-content: space-between">
            <div style="display: flex;align-items: center">
              <img src="@/assets/images/common/group_member.png" style="width:.25rem;height:.2rem" alt="">
              <p>球员运动能力成绩 ( 球员数量：{{ player.length }}个 )</p>
            </div>
          </div>
          <div v-if="player.length" class="trainPlan">
            <div
              v-for="(item,index) in player"
              :key="index"
              class="planDetail"
              :style="player.length -1 === index ? 'margin:0':''">
              <div class="info">
                <img :src="item.headImgUrl || person" alt="" @error="item.headImgUrl = person">
                <p style="white-space: initial;width: 80px;text-align: center;">{{item.idName}}</p>
                <p>{{item.gender}}</p>
                <p>{{item.positionName}}</p>
<!--                <p>总分：{{item.score || '&#45;&#45;'}}</p>-->
<!--                <p>排名：{{item.ranking || '&#45;&#45;'}}</p>-->
              </div>
              <div class="box-wrap">
                <div
                  v-for="(itm,idx) in item.dataInfoVos"
                  :key="itm.idNumber + idx"
                  class="box">
                  <p class="indicatorName" v-if="checkNumberValue(itm.score)">{{itm.indicatorName}}&nbsp;/&nbsp;得分</p>
                  <p class="indicatorName" v-else>{{itm.indicatorName}}</p>
                  <p class="content">{{ itm.testResult || '--' }} &nbsp; <span v-if="checkNumberValue(itm.score)">/&nbsp;{{itm.score}}</span></p>
                </div>
              </div>
            </div>
          </div>
          <yioks-empty v-else style="height:280px"></yioks-empty>
        </div>
      </vue-scroll>
    </div>
    <yioks-loading v-if="loading"></yioks-loading>
  </SubContent>
</template>

<script>

import body from '@/api/body'
import person from '@/assets/images/common/person.jpg'
import { filterIdNumber, testRegionFilter, checkNumberValue } from '@/utils/yioks_filter'
export default {
  components: {
    'SubContent': () => import('@/components/layout/newSubContent')
  },
  filters: {
    filterIdNumber,
    testRegionFilter,
    checkNumberValue
  },
  data () {
    return {
      person,
      playerUuid: this.$route.query.uuid,
      body: {},
      player: [],
      loading: true,
      indicatorList: [],
      checkIndicatorList: []
    }
  },
  created () {
    this.getInfo()
  },
  methods: {
    checkNumberValue, // 处理v-if用，同filter相同
    getInfo () {
      body.getBodyDataInfo(this.playerUuid).then(res => {
        if (res.code) {
          this.$message.error(res.msg)
          this.$router.push('/')
        } else {
          this.loading = false
          this.body = res.bodyDataVo
          this.playerDataInfoList = res.playerDataInfoList
          let playerDataInfoListTmp = {}
          res.playerDataInfoList.map(item => {
            if (!playerDataInfoListTmp[item.idNumber]) {
              playerDataInfoListTmp[item.idNumber] = []
            }
            playerDataInfoListTmp[item.idNumber].push(item)
          })
          this.playerBodyResult = res.playerBodyResult
          let playerBodyResultTmp = {}
          res.playerBodyResult.map(item => {
            playerBodyResultTmp[item.playerUuid] = item
          })
          this.player = res.playerDataList.map(item => {
            if (playerDataInfoListTmp[item.idNumber]) {
              item.dataInfoVos = playerDataInfoListTmp[item.idNumber]
            }
            if (playerBodyResultTmp[item.playerUuid]) {
              item.score = playerBodyResultTmp[item.playerUuid].score
              item.ranking = playerBodyResultTmp[item.playerUuid].ranking
              item.positionName = playerBodyResultTmp[item.playerUuid].positionName
            }
            return item
          })
          this.indicatorList = res.indicatorsNormatives
          this.checkIndicatorList = res.indicatorsNormatives.map(item => {
            if (item.standard) return item.uuid
          })
        }
      }).catch(err => {
        this.loading = false
        console.error(err)
      })
    }
  }
}
</script>

<style lang="stylus" scoped>
  @import '~@/assets/css/variable'
  .scroll_wrap
    height 100%
    padding 20px 0 10px 20px
    box-sizing border-box
    overflow hidden
    .info_item
      margin 0 30px 30px 10px
      .info_title
        font-size 20px
        padding 10px 0 20px
        display flex
        align-items center
        img
          margin-right 10px
          width 26px
      .base_info
        border 1px solid #FFF
        display flex
        .info
          flex 1
        .col
          border-bottom 1px solid #FFF
          // border-right 1px solid #FFF
          padding 16px 15px
          display flex
          justify-content space-around
          span
            display inline-block
            width 100%
          &:last-child
            border-bottom 0
        .playerImg
          display flex
          flex-direction column
          justify-content center
          align-items center
          img
            width 120px
            height 120px
            /*height 1.2rem*/
            border-radius 50%
            padding 10px
          p
            text-align center
      .trainPlan
        .planDetail
          border  1px solid white
          width 100%
          display flex
          margin-bottom 15px
          .info
            padding 15px
            display flex
            flex-direction column
            align-items center
            justify-content center
            border-right 1px solid #FFF
            p
              padding-top 10px
            img
              width 80px
              height 80px
              border-radius 50%
          .box-wrap
            flex 1
            display flex
            flex-wrap wrap
            justify-content space-around
            padding 10px 5px 0
            .box
              width 130px
              display flex
              flex-direction column
              // border-right 1px solid #FFF
              // border 1px solid #FFF
              margin-bottom 10px
              p
                flex 1
                display flex
                align-items center
                justify-content center
                min-height 40px
                text-align center
              .content
                border-top 1px dashed #FFF
              .indicatorName
                color #4cd964

</style>
<style lang="stylus">
.body-info-indicator
  border 1px solid #FFF
  padding 15px 15px 5px
  .el-checkbox
    padding-bottom 10px
  .el-checkbox__input.is-checked .el-checkbox__inner, .el-checkbox__input.is-indeterminate .el-checkbox__inner
    background-color #4cd964
    border-color #4cd964
  .el-checkbox__input.is-checked+.el-checkbox__label
    color #4cd964
  .el-checkbox__inner:hover
    border-color none
  .el-checkbox__input.is-disabled+span.el-checkbox__label
    color #FFF
  .is-checked
    .el-checkbox__input.is-disabled+span.el-checkbox__label
      color #4cd964
  .el-checkbox__input.is-disabled.is-checked .el-checkbox__inner::after
    border-color #FFF
</style>
